import { Outlet } from "react-router-dom";
import { KeyboardShortcuts } from "@/components/KeyboardShortcuts";

/** Wraps every route. Lives in its own file so react-refresh stays happy —
 *  router.tsx exports the (non-component) router object, and the rule
 *  ``react-refresh/only-export-components`` won't tolerate the mix. */
export function Layout() {
  return (
    <>
      <KeyboardShortcuts />
      <Outlet />
    </>
  );
}
